import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select, Spin } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getAiAgentConfigsCozeWorkspaces } from 'src/api/aiAgentConfigs/coze/workspaces';

interface TemplateProps extends SelectProps<string> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { ...restProps } = props;

    const [options, setOptions] = useState<TemplateProps['options']>();

    const { loading } = useRequest(() => getAiAgentConfigsCozeWorkspaces(), {
        onSuccess: (res) => {
            setOptions(res.data?.map((d) => ({ value: d.id!, label: d.name! })) || []);
        },
    });

    return (
        <Select
            options={options}
            style={{ width: 200 }}
            dropdownRender={(menu) => <Spin spinning={loading}>{menu}</Spin>}
            {...restProps}
        />
    );
});

export default Template;
